import React from "react";
import { IconContainerProps } from "@mui/material";
import {
    SentimentSatisfied,
    SentimentVeryDissatisfied,
    SentimentVerySatisfied,
} from "@mui/icons-material";

export function SmileyIconContainer(props: IconContainerProps) {
    const icons: Record<number, any> = {
        1: (
            <SentimentVeryDissatisfied
                style={{ height: "50px", width: "50px" }}
            />
        ),
        2: <SentimentSatisfied style={{ height: "50px", width: "50px" }} />,
        3: <SentimentVerySatisfied style={{ height: "50px", width: "50px" }} />,
    };

    const { value, ...other } = props;
    return <span {...other}>{icons[value]}</span>;
}
